const defaultSessionData = {
  role: '',
  userToken: null,
  tokenExp: null,
  username: '',
  userId: null,
  userData: null, // Per passar dades que maneja l'usuari entre components sense haver de tornar a demanar-les al servidor
  rememberTokenIsNearlyToExpire: true, // Per defecte es mostra l'alert informant que el token caducarà aviat
  // subscriptionId: null,
};

// export const defaultPatientData = {
//  bagChanges: '',
//  dailyCodeine: '',
// };

// export const defaultPatientLocalData = {
//  birthdate: '',
//  dailyBagChangesFromServer: '',
// };

export default class DataObjects {
  constructor(type, fields) {
    switch (type) {
      case 'sessionData':
        Object.assign(this, defaultSessionData, fields);
        break;
        // case 'patientData':
        // Object.assign(this, defaultPatientData, fields);
        // break;
        // case 'patientLocalData':
        // Object.assign(this, defaultPatientLocalData, fields);
        // break;
    }
  }
}
